// extracted by mini-css-extract-plugin
module.exports = {"mediaBlock":"MediaBlock_mediaBlock__Yx_Ez","fullBlock":"MediaBlock_fullBlock__16F7U"};